import React from 'react';

function TributeViewer({personName, memorialMessage, fromName, selectedCandle, title}) {
    if (!selectedCandle) {
        return <div>Ładowanie...</div>;
    }

    return (
        <div className="tribute-preview-container">
            {title && <h2>{title}</h2>}
            <div className="tribute-preview">
                <div className="candle-image-container">
                    <img src={selectedCandle.image} alt={selectedCandle.name}/>
                </div>
                <div className="preview-text-box">
                    <p className="memory-of">Ku pamięci</p>
                    <p className="person-name">{personName || "..."}</p>
                </div>
                <p className="memorial-message">"{memorialMessage || 'Wiadomość od serca...'}"</p>
                <p className="from-whom-text">{fromName || "..."}</p>
                <p className="fade-away-text">Światło, które nigdy nie zgaśnie. <br/> Zapal wirtualny znicz na{" "}
                    <a
                        href="https://japamietam.pl"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="jpm-link"
                    >
                        japamietam.pl
                    </a>
                </p>
            </div>
        </div>
    );
}

export default TributeViewer;